export default __webpack_public_path__ + "static/media/firefox-logo.88fa3a4f.svg";